<template>
  <div>
    <v-card outlined class="child-profile py-2 px-5">
      <v-row>
        <v-col class="d-flex">
          <img :src="noAvatar" alt="" />
          <div class="ml-4">
            <div class="title">
              <v-icon>account_circle</v-icon>
              {{ child.full_name }}
            </div>
            <v-btn
              :disabled="parent.has_limited_access"
              @click="$router.push({ name: 'AgreementView' })"
            >
              <v-icon left>assignment</v-icon> Договор Оферты
            </v-btn>
          </div>
        </v-col>
        <v-col>
          <div class="title">Настройка временных рамок</div>
          <v-row justify="end">
            <v-col>
              <v-checkbox
                v-model="smsLimitTimeOn"
                :disabled="parent.has_limited_access"
                :label="`Включить ограничения`"
                @change="updateSmsLimitOptions"
                class="mt-0"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-row v-if="smsLimitTimeOn">
                <v-col md="2">
                  <v-select
                    v-model="smsLimitTimeFrom"
                    :disabled="parent.has_limited_access"
                    :label="`С`"
                    :items="smsSelectRangeValues"
                    dense
                  ></v-select>
                </v-col>
                <v-col md="2">
                  <v-select
                    v-model="smsLimitTimeTo"
                    :disabled="parent.has_limited_access"
                    :label="`По`"
                    :items="smsSelectRangeValues"
                    dense
                  ></v-select>
                </v-col>
                <v-col md="3">
                  <v-btn @click="updateSmsLimitOptions">Сохранить</v-btn>
                </v-col>
              </v-row>
              <v-btn>Сохранить</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-3" />
      <v-row v-if="child.cards.length !== 0">
        <v-col
          cols="6"
          class="child-profile-cards"
          v-for="card in child.cards"
          :key="card.id"
        >
          <v-card>
            <v-col>
              <p class="subtitle-1">
                <strong>
                  <v-icon left size="24">credit_card</v-icon>Пропуск ID:
                  {{ card.number }}
                </strong>
              </p>
              <p>
                Статус:
                <strong
                  :class="[
                    { 'red--text text--lighten-1': card.is_blocked },
                    { 'green--text text--lighten-1': !card.is_blocked },
                  ]"
                >
                  {{ card.is_blocked ? "заблокирован" : "активен" }}
                </strong>
              </p>
              <p>
                Действителен до: <span>{{ card.expired_at | date }}</span>
              </p>
              <v-btn
                v-if="card.is_blocked"
                :disabled="parent.has_limited_access"
                @click="unlockCard(card)"
              >
                <v-icon left>lock_open</v-icon> Разблокировать
              </v-btn>
              <v-btn
                v-else
                outlined
                :disabled="parent.has_limited_access"
                @click="openBlockCardModal(card)"
              >
                <v-icon left>lock</v-icon> Заблокировать
              </v-btn>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <div class="subtitle-1"><strong>Внимание!</strong></div>
          Карт нет. Обратитесь к классному руководителю или в администрацию
          школы для получения карты доступа.
        </v-col>
      </v-row>
    </v-card>
    <Modal
      :dialog.sync="modals.blockCard"
      :title="'Заблокировать пропуск'"
      :contentClass="'esh-theme_parent parentModal'"
      :btnText="'Заблокировать'"
      @handler="blockCard"
      :width="500"
    >
      <template #body>
        <v-select
          :items="blockReasons"
          v-model="blockCardReason"
          label="Укажите причину блокировки"
          item-value="alias"
          item-text="name"
          return-object
        ></v-select>
        <v-textarea
          v-if="blockCardReason.alias === 'CUSTOM'"
          name="textarea"
          outlined
          label="Введите причину блокировки"
          v-model="blockCardReasonText"
        ></v-textarea>
      </template>
    </Modal>
    <v-dialog v-model="modals.smsWarning" max-width="300">
      <v-card>
        <v-card-title class="headline">Внимание!</v-card-title>
        <v-card-text>
          Услуга недоступна. Обратитесь к классному руководителю или в
          администрацию школы для получения карты доступа.
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="modals.smsWarning = false">
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import noAvatar from "@/assets/images/noavatar_big.png";
import { mapState } from "vuex";
import { Modal } from "@/components/common";
import {
  BLOCK_CARD,
  UNLOCK_CARD,
  UPDATE_NOTIFICATION_SETTINGS,
  GET_NOTIFICATION_SETTINGS,
} from "@/requests/parent";

export default {
  name: "PersonInfoView",
  components: {
    Modal,
  },
  data() {
    return {
      noAvatar: noAvatar,
      modals: {
        blockCard: false,
        smsWarning: false,
      },
      smsLimitTimeOn: null,
      smsLimitTimeTo: 1,
      smsLimitTimeFrom: 1,
      selectedCard: {},
      blockCardReasonText: "",
      blockCardReason: {},
    };
  },
  created() {
    this.blockCardReason = this.blockReasons[0];
    this.getNotificationSettings();
  },
  computed: {
    ...mapState({
      childId: (state) => state.child.childId,
      child: (state) => state.child.data,
      parent: (state) => state.child.data.parent,
      blockReasons: (state) => state.common.constants.card_block_reasons,
      smsSelectRangeValues: () => [...Array(25).keys()].slice(1, 25),
    }),
  },
  methods: {
    async getNotificationSettings() {
      const { data } = await GET_NOTIFICATION_SETTINGS(this.childId);
      this.smsLimitTimeOn = data.sms_limit_time_on;
      this.smsLimitTimeFrom = data.sms_limit_time_from;
      this.smsLimitTimeTo = data.sms_limit_time_to;
    },
    openBlockCardModal(card) {
      this.selectedCard = card;
      this.modals.blockCard = true;
    },
    async blockCard() {
      try {
        const requestData = {
          id: this.selectedCard.id,
          data: {
            block_reason: this.blockCardReason.id,
            unlock: false,
          },
        };
        if (this.blockCardReasonText !== "") {
          requestData.data.reason_text = this.blockCardReasonText;
        }
        await BLOCK_CARD(requestData);
      } catch (error) {
        console.log(error);
      } finally {
        this.selectedCard = {};
        this.blockCardReasonText = "";
        this.$store.dispatch("GET_CHILD_DATA");
      }
    },
    async unlockCard(card) {
      try {
        const requestData = {
          id: card.id,
          data: {
            unlock: true,
          },
        };
        await UNLOCK_CARD(requestData);
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("GET_CHILD_DATA");
      }
    },
    handlerTechSupport(value) {
      if (value) {
        console.log("handlerTechSupport");
      }
    },
    handlerOfferModal(value) {
      if (value) {
        console.log("handlerOfferModal");
      }
    },
    async updateSmsLimitOptions() {
      try {
        const updateData = {
          sms_limit_time_on: this.smsLimitTimeOn,
          sms_limit_time_from: this.smsLimitTimeOn
            ? this.smsLimitTimeFrom
            : undefined,
          sms_limit_time_to: this.smsLimitTimeOn
            ? this.smsLimitTimeTo
            : undefined,
        };
        await UPDATE_NOTIFICATION_SETTINGS(this.childId, updateData);
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Не удалось обновить настройки",
        });
      } finally {
        this.getNotificationSettings();
      }
    },
  },
};
</script>

<style lang="scss">
.child-profile-checkbox {
  margin-top: 15px;
  .v-input__slot {
    margin: 0 !important;
    padding: 0 !important;
  }
  .v-messages {
    display: none;
  }
}
</style>
